<template>
  <div class="flex-1 flex-col w-full">
    <global-wrapper
      :loading="$apollo.queries.detailAgenda.loading"
      :loadingType="'CardShow'"
    >
      <vx-card v-if="!$apollo.queries.detailAgenda.loading">
        <template slot="no-body">
          <global-header :buttonBack="true" :actions="false">
            <template
              slot="actions-custom"
              v-if="!$apollo.queries.detailAgenda.loading"
            >
              <vs-button
                @click="editAgenda"
                type="border"
                color="success"
                icon-pack="feather"
                icon="icon-edit"
                ><div class="hidden sm:block">Edit</div></vs-button
              >
            </template>
          </global-header>
          <div class="w-full flex flex-col p-5 pt-0">
            <div class="w-full flex flex-col">
              <div class="font-bold">Judul Agenda :</div>
              <div>{{ detailAgenda.judul }}</div>
            </div>
            <vs-divider></vs-divider>
            <div class="w-full flex flex-col">
              <div class="font-bold">Deskripsi :</div>
              <div
                v-if="detailAgenda.deskripsi != null"
                v-html="detailAgenda.deskripsi"
              ></div>
              <div v-else>-</div>
            </div>
            <vs-divider></vs-divider>
            <div class="w-full flex flex-col">
              <div class="font-bold">Peserta :</div>
              <div
                v-if="detailAgenda.peserta != null"
                v-html="detailAgenda.peserta"
              ></div>
              <div v-else>-</div>
            </div>
            <vs-divider></vs-divider>
            <div class="w-full flex flex-col">
              <div class="font-bold">Lokasi :</div>
              <div>{{ detailAgenda.lokasi }}</div>
            </div>
            <div class="w-full flex flex-col" v-if="detailAgenda.surat">
              <div class="font-bold">Berdasarkan Surat :</div>
              <div>{{ detailAgenda.surat.index }}</div>
            </div>
            <vs-divider></vs-divider>
            <div class="w-full flex flex-col md:flex-row">
              <div class="w-full flex flex-col flex-1 mb-5 md:mb-0">
                <div class="font-bold">Mulai :</div>
                <div>{{ detailAgenda.waktu_mulai | indonesian_date_time }}</div>
                <div class="text-grey">
                  {{ detailAgenda.waktu_mulai | indonesian_from_now }}
                </div>
              </div>
              <div class="w-full flex flex-col flex-1">
                <div class="font-bold">Selesai :</div>
                <div v-if="detailAgenda.waktu_selesai !== null">
                  {{ detailAgenda.waktu_selesai | indonesian_date_time }}
                </div>
                <div v-else>Sampai Selesai</div>
              </div>
            </div>
            <vs-divider></vs-divider>

            <div class="w-full flex flex-col">
              <div class="font-bold">Kategori :</div>
              <div>
                <vs-chip class="md-2" color="primary">
                  <vs-avatar
                    icon-pack="feather"
                    icon="icon-tag"
                    color="primary"
                  />
                  {{ detailAgenda.kategori_agenda.nama }}
                </vs-chip>
              </div>
            </div>

            <vs-divider></vs-divider>
            <div class="w-full flex flex-col">
              <div class="font-bold">File Laporan Agenda :</div>
              <br />
              <AgendaFile
                :agenda="detailAgenda"
                @submitCallback="handleOnSubmitCallback"
              />
            </div>
            <vs-divider></vs-divider>
          </div>
          <div class="w-full flex p-5 pt-0">
            <vs-tabs>
              <vs-tab
                label="Undangan Pegawai"
                icon-pack="feather"
                icon="icon-users"
              >
                <div class="tab-text py-3">
                  <div
                    class="w-full"
                    v-for="(item, key) in detailAgenda.peserta_agenda"
                    :key="key"
                  >
                    <global-user
                      :src="'/images/avatar/default.jpg'"
                      :name="item.pengguna.nama"
                      :subname="item.pengguna.jabatan.nama"
                    ></global-user>
                    <vs-divider></vs-divider>
                  </div>
                </div>
              </vs-tab>
              <vs-tab
                label="Komentar"
                icon-pack="feather"
                icon="icon-message-square"
              >
                <div class="w-full">
                  <global-wrapper :loading="$apollo.queries.komentar.loading">
                    <global-comment
                      v-if="komentar"
                      :comments="komentar"
                      :commentableData="commentableData"
                    ></global-comment>
                  </global-wrapper>
                </div>
              </vs-tab>
            </vs-tabs>
          </div>
        </template>
      </vx-card>
    </global-wrapper>
  </div>
</template>

<script>
import { GET_DETAIL } from "@/query/agenda";
import { GET_ALL_KOMENTAR } from "@/query/komentar";
import AgendaFile from "./components/AgendaFile";

export default {
  components: {
    AgendaFile
  },
  data() {
    return {
      detailAgenda: {}
    };
  },
  computed: {
    commentableData() {
      return {
        id: this.detailAgenda.id,
        uuid: this.detailAgenda.uuid,
        type: "App\\Models\\Agenda",
        additionalData: {
          penggunaList: {}
        }
      };
    }
  },

  apollo: {
    detailAgenda: {
      query: GET_DETAIL,
      update: data => data.agendaByUuid,
      variables() {
        return {
          id: this.$route.params.uuid
        };
      }
    },
    komentar: {
      query: GET_ALL_KOMENTAR,
      update: data => data.komentar.data,
      variables() {
        return {
          perPage: 1000,
          komentar_id: null, // get komentar if komentar_id / parent_id null
          komentarable_id: this.commentableData.id,
          komentarable_type: this.commentableData.type
        };
      }
    }
  },
  created() {
    this.$store.dispatch("globalApp/setHeaderTitle", "Detail Agenda");
  },
  mounted() {
    // this.$apollo.queries.detailAgenda.refetch();
  },
  watch: {
    commentableData: {
      handler() {
        let penggunaList = [];
        this.detailAgenda.peserta_agenda.map(item => {
          if (this.$sanctum.getUser().id != item.pengguna_id) {
            penggunaList.push(item.pengguna_id);
          }
        });

        this.commentableData.additionalData["penggunaList"] = penggunaList;
      }
    }
  },
  methods: {
    editAgenda() {
      this.$router.push({
        name: "agenda-edit",
        params: { uuid: this.$route.params.uuid }
      });
    },
    handleOnSubmitCallback() {
      this.$nextTick(() => {
        this.$apollo.queries.detailAgenda.refetch();
      });
    }
  }
};
</script>
